import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Spinner } from '@/components/ui';
import { selectIsAuthenticated, selectIsInitializing } from '@/store/auth/authSelectors';
import { selectUserProfile } from '@/store/user/userSelectors';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isInitializing = useSelector(selectIsInitializing);
  const userProfile = useSelector(selectUserProfile);
  const location = useLocation();

  if (isInitializing) {
    return <Spinner size="xl" fullScreen />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  // TODO (2.6): Render AccountRecoveryBanner if userProfile?.deleted_at is set
  if (userProfile?.deleted_at) {
    return <div>Account recovery — coming in 2.6</div>;
  }

  return children;
};

export default ProtectedRoute;
